module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/top/img_result16-fd91b726d22d2afb7a6c1c346e769e80.png";